import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate,
  type LinkProps,
} from "@tanstack/react-router";
import { Header } from "@/components/universal/header";
import { FormCombobox } from "@/components/ui/form-combobox";
import { LayoutDashboard, TrendingUp } from "lucide-react";

export const Route = createFileRoute("/_private/_warehouse-360/_analytics")({
  component: AnalyticsLayout,
});

function AnalyticsLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPage: LinkProps["to"] = location.pathname.includes(
    "monthly-historic",
  )
    ? "/warehouse360-analytics/monthly-historic"
    : "/warehouse360-analytics";

  return (
    <div className="pb-4">
      <Header
        crumbs={[
          {
            name: "Analytics Dashboards",
            link: { to: "/warehouse360-analytics" },
          },
        ]}
      >
        <FormCombobox
          options={[
            {
              group: "Warehouse Dashboards",
              items: [
                {
                  label: "Analytics",
                  value: "/warehouse360-analytics",
                  icon: LayoutDashboard,
                },
                {
                  label: "Monthly Historic",
                  value: "/warehouse360-analytics/monthly-historic",
                  icon: TrendingUp,
                },
              ],
            },
          ]}
          value={currentPage}
          onChange={(value) =>
            value && navigate({ to: value as LinkProps["to"] })
          }
          className={"w-full sm:w-48"}
        />
      </Header>
      <Outlet />
    </div>
  );
}
